module.exports = __webpack_public_path__ + "static/newsletter-e550b9da21965778ab65ed088781b6ec.png";